/**
 * NIE WIEDER EINE WEISSE SEITE OHNE GRUND (.478).
 *
 * ORIGINALTEXT MARVIN (23.10.2026)
 *   „Das ist jetzt schon das zweite Mal, dass nach dem Update die Webseite
 *    als auch das Programm nicht zu erreichen ist. Es kommt kein Fehler,
 *    nichts."
 *
 * Wirft ein Bauteil beim Zeichnen einen Fehler, baut React den ganzen Baum ab
 * und es bleibt die leere Fläche. Dieser Fang steht um die ganze Oberfläche:
 * er zeigt, was passiert ist, mit „Neu laden", und schickt den Fehler an den
 * Server, damit er im Protokoll steht.
 *
 * .597: „Neu laden" bleibt auf derselben Maske (Adresse bleibt stehen). Marvin: „dann bitte danach die
 * gleiche Maske wieder laden, wo wir aufgehört haben."
 */
import { Component, type ReactNode } from 'react';

export class Absturzfang extends Component<{ children: ReactNode }, { fehler: Error | null }> {
  state = { fehler: null as Error | null };
  static getDerivedStateFromError(fehler: Error) { return { fehler }; }
  componentDidCatch(fehler: Error, info: { componentStack?: string | null }) {
    try {
      void fetch('/api/fehler-oberflaeche', {
        method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'include',
        body: JSON.stringify({ text: String(fehler?.message ?? fehler).slice(0, 500), stapel: String(info?.componentStack ?? '').slice(0, 2000), adresse: location.hash }),
      }).catch(() => null);
    } catch { /* der Fang selbst darf nie werfen */ }
  }
  render() {
    if (!this.state.fehler) return this.props.children;
    return (
      <div style={{ maxWidth: 640, margin: '80px auto', padding: 24, fontFamily: 'system-ui, sans-serif', background: '#fff', border: '1px solid #e3e6ea', borderRadius: 10 }}>
        <h2 style={{ marginTop: 0 }}>Die Oberfläche ist abgestürzt</h2>
        <p>Das liegt an der Seite, nicht an den Daten; gespeichert ist alles. Bitte neu laden. Kommt es wieder, ein Bild dieser Meldung schicken.</p>
        <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f6f8', padding: 10, borderRadius: 6, fontSize: 12 }}>{String(this.state.fehler?.message ?? this.state.fehler)}</pre>
        <button type="button" onClick={() => location.reload()} style={{ padding: '8px 14px' }}>Neu laden</button>
        <button type="button" onClick={() => { location.hash = '#/'; location.reload(); }} style={{ padding: '8px 14px', marginLeft: 8 }}>Zur Startseite</button>
      </div>
    );
  }
}
